import { atom } from 'jotai';
import { emptyJwtPayload, JwtPayloadType } from '@/types/jwtTypes';

export const jwtDecodedAtom = atom<JwtPayloadType>({ ...emptyJwtPayload });
